import "reflect-metadata";

import {
  Injectable as Injectable0,
  Provider,
  ReflectiveInjector as ReflectiveInjector0
} from "injection-js";

class InjectorAdapter {
  private injector!: ReflectiveInjector0;
  private providers: Provider[] = [];

  add<T>(provider: Newable<T>): void {
    this.providers = [...this.providers, provider];
  }

  /**
   * Resolve `token` (typically an abstract class declared by a library as an
   * outbound port) to the existing singleton of `useExisting` (the concrete
   * class registered by the application). Must be called before `init()`.
   */
  bind<T>(token: Abstract<T>, useExisting: Newable<T>): void {
    // A binding added after init() would be silently ignored.
    if (this.injector) {
      throw new Error("injector.bind() must be called before init()");
    }
    this.providers = [...this.providers, { provide: token, useExisting }];
  }

  factory<T>(provider: Newable<T>): T {
    return ReflectiveInjector0.resolveAndCreate([provider], this.injector).get(
      provider
    );
  }

  get<T>(provider: Newable<T> | Abstract<T>): T {
    return this.injector.get(provider) as T;
  }

  init() {
    this.injector = ReflectiveInjector0.resolveAndCreate(this.providers);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Newable<T> = { new (...args: any[]): T };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Abstract<T> = abstract new (...args: any[]) => T;

const injector = new InjectorAdapter();

export { injector };

export const Injectable =
  () =>
  <T>(provider: Newable<T>) => {
    injector.add(provider);
    return Injectable0()(provider);
  };
